<script>
  import { _ as t } from "svelte-i18n";

  import List from "layouts/List.svelte";
  import Lawcase from "./Lawcase.svelte";

  export let lawcases;
</script>

<List title={$t("content.myCases")}>
  <div slot="content">
    {#each lawcases as lawcase (lawcase.id)}
      <Lawcase {lawcase} />
    {/each}
  </div>
</List>
